import * as React from "react";

const CloseOutline: React.FC = () => {
    return <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-201.000000, -413.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(122.000000, 183.000000)">
                    <polygon points="17.1 15.8 15.6 17.3 11.9 13.5 8.1 17.3 6.6 15.8 10.4 12 6.7 8.2 8.2 6.7 12 10.5 15.9 6.7 17.4 8.2 13.4 12"></polygon>
                    <path d="M12,2 C17.5,2 22,6.5 22,12 C22,17.5 17.5,22 12,22 C6.5,22 2,17.5 2,12 C2,6.5 6.5,2 12,2 L12,2 Z M12,0 C5.4,0 0,5.4 0,12 C0,18.6 5.4,24 12,24 C18.6,24 24,18.6 24,12 C24,5.4 18.6,0 12,0 L12,0 L12,0 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(CloseOutline);
